module.exports = __webpack_public_path__ + "static/media/community13.2f9d4178.svg";